import AOS from 'aos';
import { scrollTrigger } from './scrollTrigger';
import { CountUp } from 'countup.js';

// Scrolling animations
AOS.init({
    once: true,
    easing: 'ease-in-out',
    duration: 600,
});

// Toggle the mobile nav
document.querySelector('.navbar-burger').addEventListener('click', function(e) {
    e.preventDefault();
    this.classList.toggle('is-active');
    document.querySelector('.horizontal-menu').classList.toggle('is-active');
    document.body.classList.toggle('is-active');
})

// Hero tweak to only animate in the left/right images once (prevents animation on resize)
if (document.querySelector(".hero h1")) {
    window.addEventListener("load", function(){
        setTimeout(function() {
            document.querySelector(':not(.home) .hero h1').classList.add('notransition');
        }, 2000)
    });
}

if (document.querySelector(".stats-container")) {
    window.addEventListener("load", function(){
        setTimeout(function() {
            document.querySelector('.stats').classList.add('notransition');
        }, 2000)
    });
}

// Partnerships form
if (document.querySelector("#ExpertiseAreas")) {
    document.querySelector("#ExpertiseAreas .last input[type='checkbox']").addEventListener('change', function() {
        if (this.checked) {
            document.querySelector(".expertise-input-other").classList.remove('hidden');
        } else {
            document.querySelector(".expertise-input-other").classList.add('hidden');
        }
    });
}

// if (document.querySelector(".home")) {
//     const easingFn = function (t, b, c, d) {
//         var ts = (t /= d) * t;
//         var tc = ts * t;
//         return b + c * (tc + -3 * ts + 3 * t);
//     }
    
//     let stat1 = document.querySelector('.stats div:nth-of-type(1) .stat');
//     let stat2 = document.querySelector('.stats div:nth-of-type(2) .stat');
//     let stat3 = document.querySelector('.stats div:nth-of-type(3) .stat');

//     const countUp1 = new CountUp(stat1, stat1.dataset.target, {
//         startVal: stat1.dataset.start,
//         separator: ',',
//         easingFn
//     });
//     const countUp2 = new CountUp(stat2, stat2.dataset.target, {
//         startVal: stat2.dataset.start,
//         separator: ',',
//         easingFn
//     });
//     const countUp3 = new CountUp(stat3, stat3.dataset.target, {
//         startVal: stat3.dataset.start,
//         separator: ',',
//         easingFn
//     });

//     window.addEventListener('load', () => {
//         scrollTrigger('.stats', {
//             rootMargin: '-100px',
//             cb: function(el){
//                 el.classList.add('inview')
//                 if (countUp1 && !countUp1.error) {    
//                     setTimeout(() => {
//                         countUp1.start();
//                       }, 500)    
//                 }
//                 if (countUp2 && !countUp2.error) {    
//                     setTimeout(() => {
//                         countUp2.start();
//                       }, 500)    
//                 }
//                 if (countUp3 && !countUp3.error) {    
//                     setTimeout(() => {
//                         countUp3.start();
//                       }, 500)    
//                 }
//             }
//         })
//     });
// }